<template>
	<v-layout row wrap class="store-card">
		<v-flex xs4 class="store-card-left">
			<div class="store-card-image">
				<img
					:src="store.logo"
					:alt="`tienda ${store.name}`"
					height="48"
				/>
			</div>
		</v-flex>
		<v-flex xs8 class="store-card-column">
			<v-layout row wrap>
				<v-flex xs12>
					<h2 class="w-black fs-14 newwarning--text text-uppercase">
						{{ store.name }}
					</h2>
				</v-flex>
				<v-flex xs12>
					<h2 class="w-medium caption newwarning--text text-uppercase mb-2">
						{{ store.category.name }}
					</h2>
				</v-flex>
				<v-flex xs12>
					<p class="caption newprimary--text mb-0">
						{{ store.distance }} de distancia
					</p>
				</v-flex>
				<v-flex xs12>
					<p class="caption newaccent--text mb-0">
						{{ store.address }}
					</p>
				</v-flex>
				<v-flex xs12 hidden-sm-and-down>
					<v-btn
						class="store-card-btn ma-0"
						color="primary"
						depressed
						flat
						outline
						@click="$emit('visit-store', store)"
					>
						Visitar tienda
					</v-btn>
				</v-flex>
			</v-layout>
		</v-flex>
		<v-flex xs12 class="store-card-btn-mobile" align-end hidden-md-and-up>
			<v-btn
				class="store-card-btn ma-0"
				color="primary"
				depressed
				@click="$emit('visit-store', store)"
			>
				Visitar tienda
			</v-btn>
		</v-flex>
	</v-layout>
</template>

<script>
	export default {
		name: 'store-card',
		props: {
			store: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.store-card {
		background-color: color(white);
		border: 1px solid color(cardborder);
		border-radius: 10px;
		margin-bottom: 10px;
		min-height: 151px;
		padding: 12px 0px 0px;

		@media (min-width: 600px) {
			margin-right: 12px;
		}

		@media (min-width: 936px) {
			padding: 12px 12px 22px;
		}

		&-image {
			align-items: center;
			background-color: color(white);
			border-radius: 100%;
			box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.17);
			display: flex;
			height: 79px;
			justify-content: center;
			width: 79px;
		}

		&-btn {
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
			height: 39px;
			width: 100% !important;

			@media (min-width: 936px) {
				border-radius: 5px !important;
				height: 41px;
				margin-top: 13px !important;
				width: auto !important;
			}
		}

		&-btn-mobile {
			display: flex;
		}

		&-column {
			padding-left: 5px;

			@media (min-width: 768px) {
				padding-left: 12px;
			}

			@media (min-width: 1280px) {
				padding-left: 0px;
			}
		}

		&-left {
			padding-left: 12px;

			@media (min-width: 936px) {
				padding-left: 0px;
			}
		}
	}

	.store-container {
		&:nth-child(3n) {
			.store-card {
				@media (min-width: 936px) {
					margin-right: 0px;
				}
			}
		}

		&:nth-child(2n):not(:nth-child(3n)) {
			.store-card {
				@media (min-width: 600px) {
					margin-right: 0px;
				}

				@media (min-width: 936px) {
					margin-right: 12px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/store-card.vue